<template>
  <section class="fe-feat" aria-labelledby="firma-escrituras-features-title">
    <div class="fe-feat__heading">
      <h2 id="firma-escrituras-features-title" class="wd-title">
        <span class="hl">Características</span> <span class="fe-feat__base">generales</span>
      </h2>
      <p class="wd-body">Lo que incluye este momento clave</p>
    </div>

    <ul class="fe-feat__list">
      <li v-for="feature in features" :key="feature" class="fe-feat__item">
        <img :src="checkIcon" alt="" aria-hidden="true">
        <span class="wd-body" v-html="feature" />
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
import checkIcon from '../../../assets/firma-escrituras-figma/check.svg'

const features = [
  'Atención personalizada y adaptada a tus necesidades con un equipo <br class="br-t">de asesores <br class="br-m">a tu lado.',
  'Programación y confirmación de cita a través de tu medio de contacto preferido (correo electrónico, llamada telefónica o mensaje de texto).',
  'Entrega inmediata del comprobante de pago correspondiente al trámite <br class="br-m">una vez firmada la escritura.'
]
</script>

<style scoped>
.fe-feat { display: flex; flex-direction: column; gap: var(--ds-space-7); }

.fe-feat__heading { display: flex; flex-direction: column; gap: var(--ds-space-3); }
.fe-feat__heading .wd-body { min-height: 32px; }
.fe-feat__base { color: var(--ds-purple-900); }
.fe-feat .wd-title { height: 40px; line-height: 44px; }

.fe-feat__list { display: flex; flex-direction: column; gap: var(--ds-space-4); margin: 0; padding: 0; list-style: none; }
.fe-feat__item {
  display: flex;
  align-items: center;
  gap: var(--ds-space-4);
  padding: var(--ds-space-4);
  box-sizing: border-box;
  background: var(--ds-grey-50);
  border-radius: 16px;
}
.fe-feat__item img { flex: 0 0 24px; width: 24px; height: 24px; object-fit: contain; }

@media (max-width: 1024px) {
  .fe-feat { gap: var(--ds-space-6); }
}
</style>
